import React from "react";

interface Props { }

export const VolumeLoudIconComponent: React.SFC<Props> = () => {
  return (
    // tslint:disable:max-line-length
    <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 6L12 0V24L6 18H0V6H6Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M15 18V6H18V18H15Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M21 21V3H24V21H21Z" />
    </svg>
    // tslint:enable:max-line-length
  );
};
